export const downloadFile =  (reportName: string, data: any) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    const isoDateString = new Date().toISOString();
    const cleanDateString = isoDateString
      .replace(/[^a-zA-Z0-9-]/g, "")
      .replace(/[TZ]/g, "")
      .substring(0, 14);
    link.href = url;
    link.setAttribute(
      "download",
      `ReportHub-${reportName}-${cleanDateString}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  };